import { profile } from "@shared/api/services"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useUpdateUserPreference = ({onSuccess}) => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: profile.updateUserPreference,
    onSuccess: () => {
      queryClient.invalidateQueries(['profile'])
			onSuccess()
    },
  })

	return mutation
}